import { useContext, useMemo } from "react";
import { ParentContext } from "../ParentContext";

export const useImage = ({ fileType, fileName, itemData, imageMapType, itemLocation, imageProps, _appImage }) => {

  const { email, _itemKey } = itemData ?? {}
  const _isEmail = email ? true : false

  let _fileName = email ? email : _itemKey

  if (fileName) {
    _fileName = fileName
  }

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { eventInfo_state, storage_state } = states;
  const { appStorageUrlFiles } = storage_state;

  const { appGlobalData, appDataDocuments } = eventInfo_state ?? {}

  if (imageMapType && itemLocation?.[0]) {
    const _mapFieldName = 'locations'
    const _appDataDocument = appDataDocuments?.[_mapFieldName]
    const _locationKey = itemLocation?.[0]
    const _appDataDoc = _appDataDocument?.[_locationKey]
    _fileName = _appDataDoc?.name
  }

  if (imageProps?.fileName) {
    _fileName = imageProps?.fileName
  }

  if (imageProps?.selectedImagePath) {
    const ips = imageProps.selectedImagePath.split('.')
    const ipss = ips[ips.length - 1]
    _fileName = ipss
  }

  if (imageProps?.image_path) {
    const ips = imageProps.image_path.split('.')
    const ipss = ips[ips.length - 1]
    _fileName = ipss
  }

  const { currentUrls, currentFileName, currentImagePath, currentParentPath } = useMemo(() => {

    const foundImage = findObjectByKey(appStorageUrlFiles, _fileName)

    if (foundImage) {
      const { urls, profile, imageKey, imagePath, parentPath, full, thumbnail } = foundImage ?? {};
      const _urls = { full, thumbnail }
      const finalUrls = profile?.urls || urls || _urls || null;

      let _imagePath = imagePath;
      let _parentPath = parentPath;

      if (_imagePath) {
        _imagePath = _imagePath.replace('clientProfiles', 'profiles')
        _parentPath = _parentPath.replace('clientProfiles', 'profiles')
      }

      if (finalUrls.full && !finalUrls.thumbnail) {
        // finalUrls.thumbnail = finalUrls.full
        // console.log('finalUrls', finalUrls)
      }

      return {
        currentUrls: finalUrls,
        currentFileName: imageKey,
        currentImagePath: _imagePath,
        currentParentPath: _parentPath
      };
    }


    // ALWAYS return fallback object
    return {
      currentUrls: null,
      currentFileName: null,
      currentImagePath: null,
      currentParentPath: null
    };
  }, [appStorageUrlFiles, fileType, _fileName, imageMapType]);

  return {
    currentUrls,
    image_path_parent: currentParentPath,
    image_path: currentImagePath,
    image_type: fileType || currentFileName,
    image_name: _fileName,
    image_data: itemData,
  };
};


const findObjectByKey = (appStorageUrlFiles, keyToFind) => {

  let found = null;

  const search = (current, path = "") => {
    if (!_.isObject(current)) return;

    _.forOwn(current, (value, key) => {
      if (found) return;          // already found, stop further scanning

      const currentPath = path ? `${path}.${key}` : key;

      if (key === keyToFind) {
        const parentPath = path || "";  // <-- path before adding the key  
        found = {
          imagePath: currentPath,
          parentPath,
          imageKey: key,
          ...current[key],
        };     // <-- return the object/value at that key
        if (found[0]) {
          found = found[0]
        }
        return;
      }

      // Recurse into objects or arrays
      if (_.isObject(value)) {
        search(value, currentPath);
      }
    });
  };

  search(appStorageUrlFiles);
  return found;
};
